import React, { useState } from 'react';

const ImageThumbmails = ({ src, onClick, alt }) => {
  const [loaded, setLoaded] = useState(false);

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick();
    }
  };

  return (
    <img
      style={{
        opacity: loaded ? 1 : 0,
        transitionDuration: '600ms',
        cursor: 'pointer',
      }}
      onLoad={() => setLoaded(true)}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      src={src}
      alt={alt}
      tabIndex={0}
      role="button"
      aria-label={`View larger image: ${alt}`}
    />
  );
};

export default ImageThumbmails;
